import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATUlEQVR42m2MsQ5AQBAF7/+/SK2ko6CSKBAFcpxGdneoLsRN9ZI3GUfEOIaa0Be8EBdvU8YqY27yZ9tfULlYuhI/tZhKuhD8yrlvn8INC1N8mQ+k60EAAAAASUVORK5CYII="};
